import styled from 'styled-components';

export const Container = styled.div`
  height: 100%;
  justify-content: center;
  display: flex;
  align-items: center;
`;

export const Text = styled.p`
  color: ${({ theme }) => theme.palette.text.secondary};
  margin: 0;
  font-size: 14px;
`;
